import { Box, Button, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'

import {
  MUMContext,
  MUMContextInterface,
} from '../../../providers/MUM/MUMProvider'
import {
  BACContext,
  BACContextInterface,
} from '../../../providers/PatientChartPage/BACProvider'
import { themeColors } from '../../../theme'
import { Modal } from '../../Modal/Modal'
import { useStyles } from '../PatientChartPage.styles'

interface FlagBacMumForIncidentModalInterface {
  routedPatientId: string | undefined
  recordId?: number
  selectedReviewOption: string
  showFlagForIncidentModal: boolean
  setShowFlagForIncidentModal: React.Dispatch<React.SetStateAction<boolean>>
  setFilteredDataWithVideos?: React.Dispatch<React.SetStateAction<any[]>> | null
}

export const FlagBacMumForIncidentModal = ({
  routedPatientId,
  recordId,
  showFlagForIncidentModal,
  selectedReviewOption,
  setShowFlagForIncidentModal,
  setFilteredDataWithVideos,
}: FlagBacMumForIncidentModalInterface) => {
  const { classes } = useStyles()

  const { getPatientMUMRecords, flagMumRecordForIncident } = useContext(
    MUMContext
  ) as MUMContextInterface

  const { getBacRecords, flagBacRecordForIncident } = useContext(
    BACContext
  ) as BACContextInterface

  return (
    <Modal
      open={showFlagForIncidentModal}
      setOpen={setShowFlagForIncidentModal}
      title={'Flag For Incident'}
      width={'30%'}
      ModalContent={
        <Box
          sx={{
            width: '92%',
            margin: 'auto',
            padding: '10px 0',
          }}
        >
          <Typography
            sx={{
              fontSize: '20px',
              lineHeight: '25px',
              color: themeColors.grayblack,
              padding: '10px 0',
            }}
          >
            Are you sure you want to flag this video for incident?
          </Typography>
          <div className={classes.modalBtnWrapper}>
            <Button
              onClick={async () => {
                if (
                  selectedReviewOption === 'Review BAC' &&
                  recordId &&
                  setFilteredDataWithVideos
                ) {
                  await flagBacRecordForIncident(recordId)
                  if (routedPatientId) {
                    const newData = await getBacRecords(Number(routedPatientId))
                    setShowFlagForIncidentModal(false)
                    setFilteredDataWithVideos(newData)
                  }
                }

                if (
                  selectedReviewOption === 'Review MUM' &&
                  recordId &&
                  setFilteredDataWithVideos
                ) {
                  await flagMumRecordForIncident(recordId)
                  if (routedPatientId) {
                    const newData = await getPatientMUMRecords(
                      Number(routedPatientId)
                    )
                    setShowFlagForIncidentModal(false)
                    setFilteredDataWithVideos(newData)
                  }
                }
              }}
              variant='contained'
              style={{
                fontSize: '16px',
                marginTop: '10px',
                width: '180px',
                backgroundColor: themeColors.red,
                borderColor: 'transparent',
              }}
            >
              Flag for Incident
            </Button>
            <Button
              onClick={() => {
                setShowFlagForIncidentModal(false)
              }}
              variant='contained'
              style={{
                fontSize: '16px',
                marginTop: '10px',
                width: '80px',
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      }
    />
  )
}
